import React from 'react';
import { clsx } from 'clsx';

import styles from './Spinner.module.scss';

export interface SpinnerProps {
  color?: 'default' | 'white';
  size?: number;
  className?: string;
  dataTestId?: string;
}

export const Spinner = ({
  className,
  color = 'default',
  size = 20,
  dataTestId = 'loading',
  ...props
}: SpinnerProps) => (
  <span
    className={clsx(styles.spinner, className)}
    data-testid={dataTestId}
    {...props}
  >
    <span
      className={clsx(styles.graphic, color)}
      style={{
        width: `${size}px`,
        height: `${size}px`
      }}
    />
  </span>
);
